var TorsoDataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var formCollection = require('./formCollection');

/**
 * Receives forms from the FormExtService which serves the FormDTO resource
 * @class FormDataBehavior
 * @constructor
 */
module.exports = TorsoDataBehavior.extend({
  cache: formCollection
});
